import { atom, useAtom } from "jotai";
import { toast } from "react-toastify";
import dataService from "../../../helpers/dataService";

const failedJobsAtom = atom([]);
const failedJobsFiltersAtom = atom({
  filters: {
    terms: "",
    queue: "",
    type: "",
  },
  page: 1,
  nbItemsByPage: 25,
});
const isLoadingAtom = atom(false);
const paginationAtom = atom({
  count: 0,
  page: 1,
  limit: 25,
  totalPages: 0,
  hasNext: false,
  hasPrevious: false,
});

const useFailedJobs = () => {
  const [failedJobs, setFailedJobs] = useAtom(failedJobsAtom);
  const [filters, setFilters] = useAtom(failedJobsFiltersAtom);
  const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
  const [pagination, setPagination] = useAtom(paginationAtom);

  const fetchFailedJobs = (overrideFilters = null) => {
    const currentFilters = overrideFilters || filters;
    setIsLoading(true);
    dataService.post(
      "jobs/failed/search",
      currentFilters,
      (datas) => {
        setFailedJobs(datas.data);
        setPagination({
          count: datas.count,
          page: datas.page,
          limit: datas.limit,
          totalPages: datas.totalPages,
          hasNext: datas.hasNext,
          hasPrevious: datas.hasPrevious,
        });
      },
      (err) => {
        toast.error("Erreur lors du chargement des jobs échoués");
      },
      () => setIsLoading(false),
    );
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [name]: value,
      },
      page: 1,
    }));
  };

  const changePage = (page) => {
    const newFilters = { ...filters, page };
    setFilters(newFilters);
    fetchFailedJobs(newFilters);
  };

  const retryJob = (jobId) => {
    dataService.get(
      `jobs/failed/${jobId}/retry`,
      () => {
        toast.success("Job relancé avec succès");
        fetchFailedJobs();
      },
      (err) => {
        toast.error("Erreur lors de la relance du job");
      },
    );
  };

  const deleteJob = (jobId) => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce job ?")) return;
    dataService.remove(
      `jobs/failed/${jobId}`,
      {},
      () => {
        toast.success("Job supprimé avec succès");
        fetchFailedJobs();
      },
      (err) => {
        toast.error("Erreur lors de la suppression du job");
      },
      () => {},
      true,
    );
  };

  const resetFilters = () => {
    const defaultFilters = {
      filters: { terms: "", queue: "", type: "" },
      page: 1,
      nbItemsByPage: 25,
    };
    setFilters(defaultFilters);
    fetchFailedJobs(defaultFilters);
  };

  return {
    failedJobs,
    filters,
    isLoading,
    pagination,
    actions: {
      fetchFailedJobs,
      handleFilterChange,
      changePage,
      retryJob,
      deleteJob,
      resetFilters,
    },
  };
};

export default useFailedJobs;
